import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { closeModal } from "../../../store/modal";
import { FloatingWindow, WindowLayer } from "../../utility/FloatingWindow";
import "./styles.scss";
import { Thematics } from "../Thematics";
import { DayAsWindow } from "../../calendar/Day";
import { DAY_WINDOW_MIN, WINDOW_CANCEL, dayWindowSize } from "../../../functions/dayWindows";

function Modal() {
    const dispatch = useDispatch();
    const modalProps = useSelector(state => state.modal);
    const isThematicsOpen = useSelector(state => state.modal.isThematicsOpen);
    const dateFrom = useSelector(state => state.modal.date)
    const thematic = useSelector(state => state.modal.thematic)
    // The shade over the calendar, which the windows are drawn in.
    const [layer, setLayer] = useState(null);

    const close = () => dispatch(closeModal());

    // A press outside the day's windows, on the shade, closes them. A press on an element that's gone by then,
    // such as an item of a popup that closed as it was picked, isn't outside.
    const isDayOpen = modalProps.isOpen && !isThematicsOpen;
    useEffect(() => {
        if (!isDayOpen) return undefined;
        const onMouseDown = (e) => {
            if (e.target.isConnected && !e.target.closest(".floating-window")) dispatch(closeModal());
        };
        document.addEventListener("mousedown", onMouseDown);
        return () => document.removeEventListener("mousedown", onMouseDown);
    }, [isDayOpen, dispatch]);

    if (!modalProps.isOpen) {
        return null;
    }
    return (
        <div className="modal" ref={setLayer}>
            {layer && (
                <WindowLayer value={layer}>
                    {isThematicsOpen &&
                        <FloatingWindow name="thematics" resizable={false} cancel={WINDOW_CANCEL}>
                            <Thematics close={close} date={dateFrom} thematic={thematic} />
                        </FloatingWindow>
                    }
                    {!isThematicsOpen &&
                        <FloatingWindow name="day" defaultSize={dayWindowSize()} minSize={DAY_WINDOW_MIN} cancel={WINDOW_CANCEL}>
                            <DayAsWindow
                                date={modalProps.date}
                                updateID={modalProps.updateID}
                                isUpdate={modalProps.updateID !== null}
                                add={modalProps.isNew}
                                thematics={modalProps.thematics}
                            />
                        </FloatingWindow>
                    }
                </WindowLayer>
            )}
        </div>
    )
}

export { Modal };
